module.exports = __webpack_public_path__ + "img/trinity_icon_with_outline.bcba81a3.png";